module.exports = __webpack_public_path__ + "static/media/gdp-new.dedee5bf.svg";